module.exports = "\n<a class=\"fancybox\" ng-href=\"{{fullSrc}}\">\n  <img ng-src=\"{{previewSrc || fullSrc}}\" />\n</a>\n";